// extracted by mini-css-extract-plugin
module.exports = {"section":"HeaderSection-style__section--1XLSo","title":"HeaderSection-style__title--19h-T","paragraph":"HeaderSection-style__paragraph--JlNxZ"};